import { render, staticRenderFns } from "./UCWebsiteBanner.vue?vue&type=template&id=013ca520&scoped=true&"
import script from "./UCWebsiteBanner.vue?vue&type=script&lang=ts&"
export * from "./UCWebsiteBanner.vue?vue&type=script&lang=ts&"
import style0 from "./UCWebsiteBanner.vue?vue&type=style&index=0&id=013ca520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ca520",
  null
  
)

export default component.exports